import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const StickyCtaBar = ({ label = 'Start My Assessment', sublabel = 'Free assessment — limited slots today', onClick, showAfter = 550 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > showAfter);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [showAfter]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-cta-bar"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 60,
            background: 'rgba(253,248,243,0.85)',
            backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
            borderTop: '1px solid rgba(48,43,44,0.1)',
          }}
        >
          <div style={{
            maxWidth: '1024px', margin: '0 auto', padding: '12px 1.5rem',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
              <span className="pulse-dot" style={{
                width: '9px', height: '9px', borderRadius: '50%',
                background: '#0B815A', flexShrink: 0,
              }} />
              <span style={{
                fontFamily: 'var(--font-body)', fontSize: '0.8125rem', fontWeight: 600,
                color: 'rgba(48,43,44,0.75)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {sublabel}
              </span>
            </div>
            <button
              data-testid="sticky-cta-btn"
              onClick={onClick}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                padding: '11px 24px', flexShrink: 0,
                background: 'linear-gradient(135deg, #F67425, #BB0518)',
                color: '#fff', border: 'none', borderRadius: '2px',
                fontFamily: 'var(--font-heading)', fontSize: '0.875rem', fontWeight: 700,
                cursor: 'pointer', boxShadow: '0 4px 14px rgba(246,116,37,0.3)',
                transition: 'transform 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.04)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
            >
              {label} <ArrowRight size={15} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCtaBar;
